<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-nav-item v-if="menu.subMenus === undefined || menu.subMenus.length === 0" :active="menu.active"
                class="custom-menu-nav-link"
                :to="{ name: menu.url }">
      <img alt="" :src="getSvg(menu.idMenu)" class="iconMenuDesktop">
      {{ menu.nombreMenu }}
    </b-nav-item>
    <b-nav-item-dropdown :key="menu.idMenu" v-else
                         :class="'custom-menu-dropdown-menu ' + (dropDownItem ? 'dropdown-submenu' : '')">
      <template slot="button-content">
        <img alt="" :src="getSvg(menu.idMenu)" class="iconMenuDesktop">
        {{ menu.nombreMenu }}
      </template>
      <Menu :menu="subMenu" v-for="subMenu in menu.subMenus" class="w-100"
            :key="subMenu.idMenu" :dropDownItem="true"></Menu>
    </b-nav-item-dropdown>
  </div>

</template>
<script>

import Menu from "./menu.vue";

export default {
  name: "Menu",
  components: {
    Menu
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }
  },
  props: {
    menu: Object,
    dropDownItem: Boolean,
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    getSvg(url) {
      try {
        return require('../assets/menu/' + url + '.svg')
      } catch (error) {
        return require('../assets/menu/0.svg')
      }
    }
  }
};

</script>

<style scoped>

.custom-menu-dropdown-menu,
.dropdown-submenu,
.custom-menu-nav-link {
  width: 20%;
  text-align: left;
}


</style>